function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#2175D9",
  cx: 194.5,
  cy: 29.5,
  r: 29.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M194.5 76c-16.282 0-29.5 13.258-29.5 29.591V147c0-16.333 13.218-29.591 29.5-29.591S224 130.667 224 147v-41.409C224 89.258 210.814 76 194.5 76z",
  fill: "#2175D9"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#E74536",
  cx: 29.5,
  cy: 58.5,
  r: 29.5
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#FFB511",
  cx: 111.5,
  cy: 100.5,
  r: 29.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M142 176.62c0-16.349-13.218-29.62-29.5-29.62S83 160.271 83 176.62V224h59v-47.38z",
  fill: "#2175D9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.5 165.333C13.218 165.333 0 152.19 0 136v88h59v-88c0 16.222-13.186 29.333-29.5 29.333z",
  fill: "#FFB511"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#E74536",
  cx: 29.5,
  cy: 135.5,
  r: 29.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M224 147.448C224 131.194 210.782 118 194.5 118S165 131.194 165 147.448V224h59v-76.552z",
  fill: "#FFB511"
}));
function SvgHomePagePeople(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 224,
    viewBox: "0 0 224 224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePagePeople);
export default __webpack_public_path__ + "static/media/HomePagePeople.c53554f2.svg";
export { ForwardRef as ReactComponent };